// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取退出登录
export function outLogin(token, params) {
  return request({
    url: "/api/login/out_login",
    method: "get",
    params,
    headers: { token },
  });
}

// 获取修改用户信息
export function modifyUserInfor(token, data) {
  return request({
    url: "/api/user/update",
    method: "post",
    data,
    headers: { token },
  });
}

// 获取修改用户信息
export function modifyUserInfor2(token, data) {
  return request({
    url: "/api/user/update",
    method: "post",
    data,
    headers: { token: token, "Content-Type": "multipart/form-data" },
  });
}

// 获取发送重置手机号验证码
export function sendVerificationCode(token, data) {
  return request({
    url: "/api/user/send_reset_phone_code",
    method: "post",
    data,
    headers: { token },
  });
}

// 获取修改密码
export function changePassword(token, data) {
  return request({
    url: "/api/user/reset_password",
    method: "post",
    data,
    headers: { token },
  });
}

// 获取重置手机号
export function changePhoneNumber(token, data) {
  return request({
    url: "/api/user/reset_phone",
    method: "post",
    data,
    headers: { token },
  });
}

// 实名认证
export function realName(token, data) {
  return request({
    url: "/api/user/real_name",
    method: "post",
    data,
    headers: { token },
  });
}

// 用户信息综合修改
export function updateUserinfo(data) {
  return request({
    url: "/api/user/update_userinfo",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
